var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuliding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/buliding"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buliding"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.3333 30.3334H2.66663C2.11996 30.3334 1.66663 29.88 1.66663 29.3334C1.66663 28.7867 2.11996 28.3334 2.66663 28.3334H29.3333C29.88 28.3334 30.3333 28.7867 30.3333 29.3334C30.3333 29.88 29.88 30.3334 29.3333 30.3334Z",
    fill: "#2058E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28 30.3333H4C3.45333 30.3333 3 29.88 3 29.3333V7.99996C3 3.97329 5.30667 1.66663 9.33333 1.66663H22.6667C26.6933 1.66663 29 3.97329 29 7.99996V29.3333C29 29.88 28.5467 30.3333 28 30.3333ZM5 28.3333H27V7.99996C27 5.03996 25.6267 3.66663 22.6667 3.66663H9.33333C6.37333 3.66663 5 5.03996 5 7.99996V28.3333Z",
    fill: "#2058E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3334 23H9.33337C8.78671 23 8.33337 22.5467 8.33337 22C8.33337 21.4533 8.78671 21 9.33337 21H13.3334C13.88 21 14.3334 21.4533 14.3334 22C14.3334 22.5467 13.88 23 13.3334 23Z",
    fill: "#2058E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.6666 23H18.6666C18.12 23 17.6666 22.5467 17.6666 22C17.6666 21.4533 18.12 21 18.6666 21H22.6666C23.2133 21 23.6666 21.4533 23.6666 22C23.6666 22.5467 23.2133 23 22.6666 23Z",
    fill: "#2058E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.3334 17H9.33337C8.78671 17 8.33337 16.5467 8.33337 16C8.33337 15.4533 8.78671 15 9.33337 15H13.3334C13.88 15 14.3334 15.4533 14.3334 16C14.3334 16.5467 13.88 17 13.3334 17Z",
    fill: "#2058E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.6666 17H18.6666C18.12 17 17.6666 16.5467 17.6666 16C17.6666 15.4533 18.12 15 18.6666 15H22.6666C23.2133 15 23.6666 15.4533 23.6666 16C23.6666 16.5467 23.2133 17 22.6666 17Z",
    fill: "#2058E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.3334 11H9.33337C8.78671 11 8.33337 10.5467 8.33337 10C8.33337 9.45333 8.78671 9 9.33337 9H13.3334C13.88 9 14.3334 9.45333 14.3334 10C14.3334 10.5467 13.88 11 13.3334 11Z",
    fill: "#2058E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.6666 11H18.6666C18.12 11 17.6666 10.5467 17.6666 10C17.6666 9.45333 18.12 9 18.6666 9H22.6666C23.2133 9 23.6666 9.45333 23.6666 10C23.6666 10.5467 23.2133 11 22.6666 11Z",
    fill: "#2058E9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuliding);
export default __webpack_public_path__ + "static/media/buliding.ed15af9d70cf079add9d3314fde61854.svg";
export { ForwardRef as ReactComponent };